export class ApiError extends Error {
  constructor(
    message: string,
    public readonly code?: string,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

export function parseApiError(err: unknown): ApiError {
  if (err instanceof ApiError) return err;

  if (err && typeof err === 'object' && 'response' in err) {
    const response = (err as { response?: { data?: { error?: string; code?: string } } }).response;
    const data = response?.data;
    if (data?.error) {
      return new ApiError(data.error, data.code);
    }
  }

  if (err instanceof Error) return new ApiError(err.message);
  return new ApiError('Неизвестная ошибка');
}
